import React from 'react';

import BridgeAppBar from './MainComponents/BridgeAppBar';
import SearchClientes from './MainComponents/SearchClients';

export default () => (
    <div>
        <BridgeAppBar showOptions={false} />
        <SearchClientes />
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Main.js